import styled, { css } from "styled-components";
import {
  DESKTOP_MEDIA_QUERY,
  HEADER_HEIGHT,
  DESKTOP_HEADER_HEIGHT
} from "../constants";

const windowHeight =
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 24px;
`;

export const BoxesWrapper = styled.div`
  width: 100%;
  margin: 20px 0;

  ${DESKTOP_MEDIA_QUERY} {
    max-width: 768px;
    margin: 80px 0;
  }
`;

export const Box = styled.div`
  width: 100%;
  max-height: ${(windowHeight - HEADER_HEIGHT - 60) / 2}px;
  margin-bottom: 20px;
  padding: 12px 8px;
  border: 3px solid ${({ color }) => color};
  font-size: 15px;
  font-weight: bold;
  overflow: auto;
  cursor: default;

  &:last-child {
    margin-bottom: 0;
  }

  ${DESKTOP_MEDIA_QUERY} {
    max-height: ${(windowHeight - DESKTOP_HEADER_HEIGHT - 190) / 2}px;
    margin-bottom: 30px;
    padding: 12px 16px;
    font-size: 36px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Item = styled.span`
  background-color: ${({ clicked }) => (clicked ? "#FF000D" : "white")};
`;

export const BubbleOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.6);
  background-image: url(${({ b }) => b.image});
  background-size: ${({ b }) => b.width}px;
  background-position: ${({ b }) => b.pos};
  background-repeat: no-repeat;

  ${DESKTOP_MEDIA_QUERY} {
    background-image: url(${({ b }) => b.imageD});
    background-size: ${({ b }) => b.widthD}px;
  }
`;

const getBubbleTextSize = b => {
  const coords = {
    top: "auto",
    bottom: "auto",
    left: "auto",
    right: "auto",
    topD: "auto",
    bottomD: "auto",
    leftD: "auto",
    rightD: "auto"
  };

  if (b.pos === "bottom left") {
    coords.bottom = 220;
    coords.bottomD = 275;
    coords.left = 84;
    coords.leftD = 457;
  }

  if (b.pos === "bottom right") {
    coords.bottom = 220;
    coords.bottomD = 275;
    coords.right = 96;
    coords.rightD = 513;
  }

  if (b.pos === "top left") {
    coords.top = 146;
    coords.topD = 303;
    coords.left = 85;
    coords.leftD = 457;
  }

  if (b.pos === "top right") {
    coords.top = 146;
    coords.topD = 303;
    coords.right = 96;
    coords.rightD = 513;
  }

  return css`
    top: ${coords.top}px;
    bottom: ${coords.bottom}px;
    left: ${coords.left}px;
    right: ${coords.right}px;

    ${DESKTOP_MEDIA_QUERY} {
      top: ${coords.topD}px;
      bottom: ${coords.bottomD}px;
      left: ${coords.leftD}px;
      right: ${coords.rightD}px;
    }
  `;
};

export const BubbleText = styled.div`
  width: 139px;
  height: 202px;
  position: absolute;
  font-size: 18px;
  font-weight: 600;
  color: #fff;

  ${({ b }) => getBubbleTextSize(b)}

  ${DESKTOP_MEDIA_QUERY} {
    width: 470px;
    height: 446px;
    font-size: 64px;
  }
`;
